import React, { useRef, useEffect, useState } from 'react';
import { Wrapper, FixedBlockImages, Images, ImageFixed, ContainerFixImage } from './styled';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import SectionBlock from './SectionBlock';

const Sections = ({ bgColor, sectionsData, hidePriceLabel, revertDescBlocks, sizeMedium }) => {

    const wrapper = useRef(null);

    const [fixed, setFixed] = useState(false);
    const [top, setTop] = useState(true);
    // расстояние от верхней границы секции до верхней границы окна
    const [wrapperTop, setWrapperTop] = useState(0);
    // расстояние от нижней границы секции до нижней границы окна
    const [wrapperBottom, setWrapperBottom] = useState(0);
    // ндекс текстового блока, который находится в видимой части экрана, чтобы показать напротив него соответствующую картинку в зафиксированной области
    const [indexVisible, setIndexVisible] = useState(-1);

    const [isHorizontal, setIsHorizontal] = useState(true);

    useEffect(() => {
        if (wrapper && process.browser) {
 handlerScroll(wrapper.current);
}
    }, [wrapper]);

    useEffect(() => {
        if (wrapperTop < 0 && wrapperBottom > 0) {
            if (fixed) {
 return;
}
            setTop(true);
            setFixed(true);
        } else {
            if (!fixed) {
 return;
}
            if (wrapperTop >= 0) {
                setTop(true);
            }
            if (wrapperBottom <= 0) {
                setTop(false);
            }
            setFixed(false);
        }
    }, [wrapperTop, wrapperBottom, fixed, top]);

    const handlerScroll = wrapper => {

        const scrollFunction = () => {
            const textBlocks = wrapper.querySelectorAll('div[data="text-blocks"]');
            if (!textBlocks || textBlocks.length < 1) {
                return;
            }

            const textBlocksCount = textBlocks.length;
            const coordinatesWrapper = wrapper.getBoundingClientRect();
            setWrapperTop(coordinatesWrapper.top);
            setWrapperBottom(coordinatesWrapper.bottom - window.innerHeight);
            let indexVisibleBlock = textBlocks[0].getBoundingClientRect().bottom > 0
                ? 0
                : textBlocksCount - 1;

            if (textBlocks[0].getBoundingClientRect().top < 0) {
                for (let index = 0; index < textBlocks.length; index++) {
                    const textBlockTop = textBlocks[index].getBoundingClientRect().top;
                    const textBlockBottom = textBlocks[index].getBoundingClientRect().bottom;
                    if (window.innerWidth <= 929) {
                        indexVisibleBlock = index;
                        if (textBlockTop < window.innerHeight && textBlockTop > 0) {
 break;
}
                    } else if (
                            textBlockTop < window.innerHeight &&
                            textBlockBottom > 0
                        ) {
                            indexVisibleBlock = index;
                        }
                }
            }
            setIndexVisible(indexVisibleBlock);

            if (window.innerHeight < window.innerWidth) {
                setIsHorizontal(true);
            } else {
                setIsHorizontal(false);
            }
        };

        window.addEventListener('wheel', scrollFunction, false);
        window.addEventListener('scroll', scrollFunction, false);
    };

    return (
        <Wrapper ref={wrapper} isHorizontal={isHorizontal} itemProp='description'>
            <GridContainer>
                {
                    sectionsData.map((block, index) => (
                        <SectionBlock
                            key={index}
                            index={index}
                            text={block.title}
                            note={block.description}
                            image={block.image}
                            active={sectionsData.length === 1 || indexVisible === index}
                            isHorizontal={isHorizontal}
                            length={sectionsData.length}
                            hidePriceLabel={hidePriceLabel}
                            revertDescBlocks={revertDescBlocks}
                            sizeMedium={sizeMedium}
                        />
                    ))
                }
            </GridContainer>
            <FixedBlockImages
                fixed={sectionsData.length > 1 && fixed}
                top={top}
                isHorizontal={isHorizontal}
                length={sectionsData.length}
            >
                <ContainerFixImage>
                    <Images bgColor={bgColor}>
                        {
                            sectionsData.map((block, index) => (
                                <ImageFixed
                                    key={index} src={block.image}
                                    active={indexVisible === index || indexVisible === -1}
                                />
                            ))
                        }
                    </Images>
                </ContainerFixImage>
            </FixedBlockImages>
        </Wrapper>
    );
};

export default Sections;
